/*
 * @Description: 解绑登录小程序人员
 * @Author: 杨志航
 * @Date: 2026-08-26 14:15:48
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  message,
  Input,
  Table,
  Button,
  Popconfirm,
} from 'antd'
import { allTrim, filterParams } from '@/utils'

const { Column } = Table
const FormItem = Form.Item

let searchParams = {
  limit: 9999, 
  page: 1
}

const BindStaff = (props) => {
  const { getFieldDecorator, validateFields, setFieldsValue, getFieldsValue, resetFields } = props.form
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])

  useEffect(() => {
    getList()
  }, [])

  //获取已添加员工列表
  const getList = () => {
    setLoading(true)
    api.getProfitReportStaffList(searchParams).then(data => {
      setList(data)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  const formSubmit = evt => {
    evt.preventDefault()
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }

  const handleUnbind = id => {
    setLoading(true)
    api.unbindProfitReportStaff({
      id
    }).then(() => {
      message.success('解绑成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  const resetParams = () => {
    searchParams = {
      limit: 9999, 
      page: 1
    }
  }

  //重置
  const onReset = () => {
    resetFields()
    resetParams()
    getList()
  }

  return (
    <>
      <Form onSubmit={formSubmit} layout="inline">
        <FormItem label="员工姓名">
          {getFieldDecorator('staffName')(
            <Input 
              allowClear
              placeholder="请输入员工姓名" 
              style={{ width: '150px' }}
            />
          )}
        </FormItem>
        <FormItem label="">
          <Button type="primary" htmlType="submit">查询</Button>
          <Button style={{ marginLeft: '10px' }} onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
      <Table
        dataSource={list}
        rowKey={(item, index) => index}
        className="invoice-table"
        loading={loading}
        pagination={false}
      >
        <Column title="员工姓名" dataIndex="staffName" />
        <Column title="员工编号" dataIndex="staffNo" />
        <Column title="所属部门" dataIndex="departmentName" />
        <Column title="所属事业群" dataIndex="groupName" />
        <Column title="员工状态" dataIndex="isOnJob" />
        <Column title="绑定时间" dataIndex="bindTime" />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={80}
          render={(text, record) =>
            <>
              <Popconfirm 
                title="请确认是否解绑？" 
                onConfirm={() => handleUnbind(record.id)}
              >
                <a>解绑</a>
              </Popconfirm>
            </>
          }
        />
      </Table>
    </>
  )
}

export default Form.create()(BindStaff)